// Style
import style from './GridColumns.module.css';

/**
 * GridColumns component
 * A 3-column grid where each child column stacks its own items, in order.
 * Columns are stacked one after the other on small screens.
 * @param {object} props - The component props
 * @param {React.ReactNode} props.children - `GridColumnsColumn` elements
 * @returns {JSX.Element} The GridColumns component
 */
function GridColumns({ children }) {
  return (
    <div className={style['grid-columns']}>
      {children}
    </div>
  );
}

/**
 * One column of a `GridColumns` grid. An empty column keeps its place.
 * @param {object} props - The component props
 * @param {React.ReactNode} [props.children] - The items of the column, top to bottom
 * @returns {JSX.Element} The column
 */
export function GridColumnsColumn({ children = null }) {
  return (
    <div className={style['grid-columns-column']}>
      {children}
    </div>
  );
}

export default GridColumns;
